import * as React from "react";
import * as Moment from "moment";
import { DateTimeOffsetPicker } from "../../../../misc/components/DateTimeOffsetPicker";
import { LocalizedDateTime, DateTimeAccuracy } from "../../../../misc/components/LocalizedDateTime";

interface SelectNewDateTimeProps {
    originalDateTime: string;
    dateTime: string;
    onChange: (date: Moment.Moment) => void;
    onNext: () => void;
}

export const SelectNewDateTime = ({
    originalDateTime,
    dateTime,
    onChange,
    onNext
}: SelectNewDateTimeProps): JSX.Element => {
    const [isDisabled, setIsDisabled] = React.useState(false);

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            Select the date & time the <b>Recording Start Date & Time</b> and{" "}
                            <b>Session Date & Time</b> should be corrected to
                        </p>
                        <div className="form-group">
                            <label>Current Date & Time</label>
                            <div className="form-group">
                            <LocalizedDateTime
                                time={originalDateTime}
                                accuracy={DateTimeAccuracy.Second}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Corrected Date & Time</label>
                            <DateTimeOffsetPicker
                                dateTime={dateTime}
                                onChange={(value): void => {
                                    if (!value.isValid()) {
                                        setIsDisabled(true);
                                    } else {
                                        setIsDisabled(false);
                                    }

                                    onChange(value);
                                }}
                            />
                            {isDisabled ? (
                                <span style={{ color: "red" }}>Please enter a valid date time</span>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-primary"
                    type="button"
                    disabled={isDisabled}
                    onClick={onNext}
                >
                    Next
                </button>
            </div>
        </>
    );
};
